<template>
  <div>
    <!--头部-->
    <Header :showValue="4"></Header>
    <div class="jqgk" style="background:rgba(227, 227, 227, 0.84)">
      <div
        class="contai"
        style="max-width: 1197px;background-color:#fff;margin-bottom:40px;padding-left:40px;padding-right:40px"
      >
        <div class="top_tit" style="padding-top:10px;margin-top:0px">
           <div style="height:15px" v-if="pcshow"></div>
          <div class="titleShuXian" v-if="pcshow"></div>
          <span class="titleFont" v-if="pcshow">{{china}}</span>
          <span class="titleFontEnglish" v-if="pcshow">{{english}}</span>

          <div class="titleShuXianForH" v-if="!pcshow"></div>
          <span class="titleFont" style="font-size:16px" v-if="!pcshow">{{china}}</span>
          <span class="titleFontEnglishForPhone" style="font-size:12px" v-if="!pcshow">{{english}}</span>
        </div>


        <div v-if="pcshow">
          <div class="container-fluid">
            <div class="col-md-12">
              <div class="row">
                <div class="timeline">
                  <span class="timeline-label">
                    <div class="timeline-point timeline-point-blank">
                      <img
                        src="../assets/xqsimage/jialogo.png"
                        style="width:91px;height:91px;margin-top:-20px"
                      />
                    </div>
                  </span>
                  <span class="timeline-label" style="height:52px"> </span>

                  <div :v-if="pcshow"  v-for="(item, index) in dataList" :key="item.id">
                    <span class="timeline-label" v-if="item.type == 1">
                      <div class="timeline-point timeline-point-blank">
                        <div class="timeAxis">{{ item.sort }}</div>
                      </div>
                    </span>
                    <!-- 右边 -->
                    <div
                      class="timeline-item timeline-item-right"
                      v-if="index % 2 == 0"
                    >
                      <div class="timeline-point timeline-point-blank">
                        <span class="timeStyleRight">{{
                          item.title
                        }}</span>
                      </div>
                      <!-- <span class="timeStyleLeftMobile" v-if="!pcshow">{{
                        item.title
                      }}</span> -->
                      <div class="timelineText">
                        {{ item.details }}
                      </div>
                    </div>
                    <!-- 左边 -->
                    <div
                      class="timeline-item timeline-item-left"
                      v-if="index % 2 == 1"
                    >
                      <div class="timeline-point timeline-point-blank">
                        <span class="timeStyleLeft" >
                          {{ item.title }}</span
                        >
                      </div>
                      <!-- <span class="timeStyleLeftMobile" v-if="!pcshow">{{
                        item.title
                      }}</span> -->
                      <div class="timelineText">
                        {{ item.details }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="!pcshow" style="">
          <div style="height:60px;width:100%"></div>
          <div style="text-align:center;width:100%;margin-left:0.5px">
             <img src="../assets/xqsimage/jialogo.png"  style="width:35px;height:35px;"/>
          </div>
          <div style=";width:50.5%">
            <div style="height: 40px;border-right: 2px solid #888;"></div>
          </div>
          
          <div v-for="(item, index) in dataList" :key="item.id">
            
                    <span  v-if="item.type == 1">
                      <div >
                        <div class="timeAxisForP">{{ item.sort }}</div>
                      </div>
                    </span>
                    
                    <div style="width:100%;display:flex;flex-direction:row;;font-size:12px;font-family: Microsoft YaHei;">
                      
                      <div style="width:50%;display: table;" >
                        <div  v-if="index % 2 == 0" style="text-align:right;vertical-align: middle;margin-right:8px;font-family: Arial;
    font-weight: 400;
    font-style: italic;
    color: #8c8c8c;">{{ item.title }} </div>
                        <div  v-if="index % 2 == 1" style="text-align:left;background: #e6e6e6;padding:5px;margin-right:8px;border-radius:10%;color:#161616;font-weight: 600">{{ item.details }} </div>
                      </div>
                      <!-- <div class="dot"></div> -->

                      <div style="width:50%;;border-left:2px solid #888" >
                        <div v-if="index % 2 == 0"  style="text-align:left;background: #e6e6e6;padding:5px;margin-left:8px;border-radius: 10%;color:#161616;font-weight: 600;">{{ item.details }} </div>
                        <div v-if="index % 2 == 1"  style="text-align:left;margin-left:8px;font-family: Arial;  font-weight: 400;font-style: italic;color: #8c8c8c;display:flex;
  align-items:center;"><div>{{ item.title }}</div>
   </div>
                      </div>
                    </div>
                  
          </div>
        </div>
                  


      </div>
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "./header";
import Footer from "./footer";
import { gethistoryList ,getZJXQSList} from "@/api/public";
export default {
  components: { Header, Footer },
  data() {
    return {
      china:'',
      english:'',
      pcshow: false,
      choseValue: 2,
      styletable: { borderBottom: "8px solid #F2DCCA", paddingLeft: "0px" },
      mapStyle: {
        background: "#f2dcca",
        marginTop: "5px",
        paddingLeft: "39px"
      },
      dataList: []
    };
  },
  beforeCreate() {},
  created() {
    if (this._isMobile()) {
      this.pcshow = false;
    } else {
      this.pcshow = true;
    }
  },
  mounted() {
    //菜单
     getZJXQSList().then(response => {
        this.china = response.data.sort(this.compare("sort"))[3].title
        this.english = response.data.sort(this.compare("sort"))[3].enTitle
      });
    //荣誉列表
    gethistoryList().then(response => {
      let arr = response.data
      let lndexList = ""
      arr.length>0 ? lndexList=arr[0].sort : ''
      for (let i = 0; i < arr.length; i++) {
        arr[0].type = 1
        if (arr[i].sort == lndexList) {
          if (i != 0) {
            arr[i].type = 0
          }
        } else {
          lndexList = arr[i].sort
          arr[i].type = 1
        }
      }
      this.dataList = arr
    });
  },
  methods: {
     //属性排序sort
    compare(property) {
      return function(a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value1 - value2;
      };
    },
    //菜单选择
    tabSelect(e) {
      let value = e.target.dataset.index;
      this.choseValue = value;
    },
    //判断是PC端还是手机端
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      return flag;
    }
  }
};
</script>

<style>
.dot {
  position: absolute;
  top: 50%;
  margin-left: -5px;
  margin-top: -5px;
  width: 10px;
  height: 10px;
  border-radius: 100%;
  background: #ccc;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .2);
 
}
.titleFontEnglishForPhone {
  font-size: 21px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ccc;
  line-height: 66px;
  float: left;
  padding-top: 0px;
}
.titleFontEnglish {
  font-size: 21px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ccc;
  line-height: 66px;
  float: left;
  padding-top: 10px;
  padding-bottom: 15px;
}
.titleShuXian {
  height: 48px;
  margin-top: 9px;
  width: 8px;
  background-color: #840207;
  float: left;
}

.titleShuXianForH {
  height: 28px;
  margin-top: 14px;
  width: 4px;
  background-color: #840207;
  float: left;
}
.titleFont {
  font-size: 42px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #840207;
  line-height: 36px;
  float: left;
  padding: 15px;
}
.timeAxisForP{
  width: 55px;
  height: 25px;
  background: #ffffff;
  border: 2px solid #840207;
  border-radius: 17px;
  position: relative;
  /* margin-bottom: 20px; */
  margin-left: auto;
  margin-right: auto;
  color: #840207;
  font-size: 16px;
  font-family: "Arial";
  font-weight: bold;
  color: #840207;
  line-height: 25px;
}
.timeAxis {
  width: 91px;
  height: 36px;
  background: #ffffff;
  border: 2px solid #840207;
  border-radius: 17px;
  position: relative;
  margin-bottom: 20px;
  margin-left: auto;
  margin-right: auto;
  color: #840207;
  font-size: 18px;
  font-family: "Arial";
  font-weight: bold;
  color: #840207;
  line-height: 36px;
}
.timelineText {
  background: #e6e6e6;
  border: 1px solid #e1dcd3;
  font-size: 20px;
  font-family: "Source Han Sans CN";
  font-weight: bold;
  color: #161616;
  text-align: left;
  padding: 12px 20px 13px 9px;
  border-radius: 10px;
}

.timeStyleLeft {
  text-align: left;
  width: 156px;
  height: 18px;
  font-size: 24px;
  font-family: Arial;
  font-weight: 400;
  font-style: italic;
  color: #8c8c8c;
  /* float: left; */
  margin-top: -5px;
  position: absolute;
  z-index: 999;
  left: 25px;
}
.timeStyleLefttimeStyleLeftMobile {
  width: 156px;
  height: 18px;
  font-size: 24px;
  font-family: Arial;
  font-weight: 400;
  font-style: italic;
  color: #8c8c8c;

  /* float: left; */
}
.timeStyleRight {
  width: 156px;
  height: 18px;
  font-size: 24px;
  font-family: Arial;
  font-weight: 400;
  font-style: italic;
  color: #8c8c8c;
  /* float: right; */
  margin-top: -5px;
  position: absolute;
  z-index: 111;
  right: 30px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/history.vue